export default __webpack_public_path__ + "static/media/sweet-5.3b764be7.jpg";